// extracted by mini-css-extract-plugin
export var container = "_4v-0";
export var fallback = "_4v-5";
export var fallbackIcon = "_4v-6";
export var hidden = "_4v-2";
export var image = "_4v-3";
export var loaded = "_4v-4";
export var placeholder = "_4v-1";